module.exports = __webpack_public_path__ + "img/arrowBlue.3c30d2ce.svg";